/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_Session_Time_LabelInputs */

const vi_stocktake_filter_session_time_label = /** @type {(inputs: Stocktake_Filter_Session_Time_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phiên`)
};

/**

* @param {Stocktake_Filter_Session_Time_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_session_time_label = /** @type {((inputs?: Stocktake_Filter_Session_Time_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_Session_Time_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_session_time_label(inputs)
});